import { ArchiveManagerProvider } from '../archive-manager';
import { WordsManagerProvider } from '../../words-manager/words-manager';
import { Platform } from '@ionic/angular';

export class UnzipSuggestions{
    filePath: string;
    fileName: string;
    wordsMgr : WordsManagerProvider;
    platform : Platform;

    constructor(
        public archiveMgr : ArchiveManagerProvider
        ){
        this.wordsMgr = this.archiveMgr.injector.get(WordsManagerProvider);
        this.platform = this.archiveMgr.injector.get(Platform);

        if(this.platform.is("cordova")){
            this.initSuggestions();
        }
    }
    initSuggestions(){
        let outPut ="../assets/archive/out/suggestions.sql";
        let outName ="suggestions.sql";
        let path = "www/assets/archive/suggestions/";
        this.fileName = "sggstns.by";
        // this.filePath = this.archiveMgr.file.applicationDirectory+path;
        // this.isAlreadyInitialized().then(answer=>{
        //     if(answer == true){
        //         "already initilized";
        //     }
        //     else {
        //         this.archiveMgr.file.checkFile(this.filePath, this.fileName).then(res=>{
        //             this.copyExtractImportSuggestions();
        //         }).catch(err=>{
        //             this.logger.debug("error of file existance",err);
        //         });
        //     }
        // });
      }
      isAlreadyInitialized () : Promise<boolean>{
        return new Promise((resolve,reject)=>{
            this.wordsMgr.hasEnoughWordsSuggestions().then(answer=>{
                resolve(answer);
            }); 
        });
      }
      copyExtractImportSuggestions(){
        let outName ="suggestions.sql";
        let outNameFolder ="suggestions";
        let self = this;
        // this.archiveMgr.file.copyFile(this.filePath,this.fileName,this.archiveMgr.file.cacheDirectory,this.fileName).then(
        //   fileRes=>{
        //     self.archiveMgr.zip.unzip(self.archiveMgr.file.cacheDirectory+self.fileName,
        //         self.archiveMgr.file.applicationStorageDirectory+outNameFolder).then(
        //         (result)=>{
        //           if(result === 0){
                    
        //             this.logger.debug('SUCCESS');
        //             self.archiveMgr.file.checkFile(self.archiveMgr.file.applicationStorageDirectory+outNameFolder+"/",outName).then(fileRes=>{
        //                 self.archiveMgr.file.readAsText(self.archiveMgr.file.applicationStorageDirectory+outNameFolder,outName).then(sqlString=>{
        //                     // self.archiveMgr.readAsText(self.archiveMgr.file.cacheDirectory+outName).subscribe(sqlString=>{
                                
        //                         // self.archiveMgr.databaseMgr.importSQL(sqlString.text());
        //                         self.archiveMgr.databaseMgr.importSQL(sqlString);
        //                         // },
        //                         // err=>{
        //                             //     err;
        //                         })
        //                         .catch(err=>{
        //                             // this.logger.debug("err on reading file",self.archiveMgr.file.cacheDirectory,outName);
        //                         })
        //                     }).catch(fileResErr=>{
        //                         this.logger.debug(fileResErr);
        //                     })
        //           } 
        //           if(result === -1){
                    
        //             this.logger.debug('FAILED');
        //           } 
        //         }
        //       )
        //   }).catch(err=>{
        //     this.logger.debug("error in copy",err);
        //   })
      }
}